export default function HaileyStartIco() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25669 4.47754C8.80667 5.595 9.70374 6.50366 10.8132 7.06712L11.4753 7.40336C11.7164 7.52583 11.7164 7.8703 11.4753 7.99277L10.8132 8.32901C9.70374 8.89247 8.80667 9.80113 8.25669 10.9186L7.92445 11.5936C7.80333 11.8397 7.45246 11.8397 7.33133 11.5936L6.9991 10.9186C6.44911 9.80113 5.55205 8.89247 4.44256 8.32901L3.78049 7.99277C3.53933 7.8703 3.53933 7.52583 3.78049 7.40336L4.44256 7.06712C5.55205 6.50366 6.44912 5.595 6.9991 4.47754L7.33134 3.80251C7.45246 3.55641 7.80333 3.55641 7.92446 3.80251L8.25669 4.47754Z"
        fill="white"
      />
      <path
        d="M3.19764 0.807926C3.54544 1.51459 4.11273 2.08921 4.81435 2.44553L5.23303 2.65816C5.38553 2.73561 5.38553 2.95345 5.23303 3.0309L4.81435 3.24353C4.11273 3.59985 3.54544 4.17447 3.19764 4.88113L2.98754 5.30801C2.91095 5.46364 2.68906 5.46364 2.61246 5.30802L2.40236 4.88113C2.05456 4.17447 1.48727 3.59985 0.785649 3.24353L0.366966 3.0309C0.214466 2.95345 0.214466 2.73561 0.366966 2.65816L0.785649 2.44553C1.48727 2.08921 2.05456 1.51459 2.40236 0.807927L2.61246 0.381046C2.68906 0.225417 2.91095 0.225417 2.98754 0.381046L3.19764 0.807926Z"
        fill="white"
      />
    </svg>
  );
}
